import * as types from './mutation-types';

const provider = process.env.VUE_APP_PROVIDER ? `${process.env.VUE_APP_PROVIDER}` : 'authDAC';

export default {
    reset: ({ commit }) => {
        commit(types.SET_USER_ID, null);
        commit(types.SET_USER_PROFIL, {});
        commit(types.SET_USER_AUTHENTICATION, false);
        commit(types.SET_USER_PERMISSIONS, null);
    },
    login: async ({ dispatch }, data) => {
        try {
            await dispatch(`${provider}/login`, data, { root: true });
            return ;
        } catch (e) {
            throw (e);
        }
    },
    authMe: async ({ dispatch, commit }, data) => {
        try {
            const isAuth = await dispatch(`${provider}/authMe`, data, { root: true });
            commit(types.SET_USER_AUTHENTICATION, isAuth);
            return ;
        } catch (e) {
            commit(types.SET_USER_AUTHENTICATION, false);
            throw (e);
        }
    },
    getMe: async ({ dispatch, commit, getters }) => {
        try {
            if (!getters.isAuthenticated) throw dispatch('error/notAuthenticated', null, { root: true });
            const me = await dispatch(`${provider}/getMe`, null, { root: true });
            commit(types.SET_USER, me);
            return ;
        } catch (e) {
            commit(types.SET_USER_AUTHENTICATION, false);
            throw (e);
        }
    },
    logout: async ({ dispatch, commit }) => {
        try {
            await dispatch(`${provider}/logout`, null, { root: true });
            commit(types.SET_USER_AUTHENTICATION, false);
            return ;
        } catch (e) {
            throw (e);
        }
    },
    setMe: ({ commit }, me) => {
        commit(types.SET_USER, me);
    },
    setAuth: ({ commit }, isAuth) => {
        commit(types.SET_USER_AUTHENTICATION, !!isAuth);
    }
};